export default "__VITE_ASSET__BO4lPvwX__"